import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { uploadImage, formatApiError } from "@/lib/api";
import { imageUrl } from "@/lib/format";

export function ImageUpload({ value, onChange, label, testId, aspect = "aspect-square" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      onChange(await uploadImage(file));
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div>
      {label && <p className="mb-2 text-sm font-medium text-slate-800">{label}</p>}
      <button type="button" data-testid={testId} onClick={() => ref.current.click()} className={`relative flex w-full items-center justify-center overflow-hidden rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 transition-colors hover:border-sky-400 ${aspect}`}>
        {value ? <img src={imageUrl(value)} alt="" className="h-full w-full object-cover" /> : (
          <span className="flex flex-col items-center gap-1 text-sm text-slate-500"><ImagePlus className="h-6 w-6" />Upload image</span>
        )}
        {busy && <span className="absolute inset-0 flex items-center justify-center bg-white/70"><Loader2 className="h-6 w-6 animate-spin text-sky-600" /></span>}
      </button>
      <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={pick} data-testid={`${testId}-input`} />
    </div>
  );
}

export function GalleryUpload({ value = [], onChange }) {
  return (
    <div>
      <p className="mb-2 text-sm font-medium text-slate-800">Gallery (up to 8)</p>
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-4">
        {value.map((url, i) => (
          <div key={url + i} className="relative aspect-square overflow-hidden rounded-xl">
            <img src={imageUrl(url)} alt="" className="h-full w-full object-cover" />
            <button type="button" data-testid={`gallery-remove-${i}`} onClick={() => onChange(value.filter((_, j) => j !== i))} className="absolute right-1.5 top-1.5 rounded-full bg-white/90 p-1 shadow"><X className="h-3.5 w-3.5" /></button>
          </div>
        ))}
        {value.length < 8 && <ImageUpload testId="gallery-upload" value="" onChange={(url) => onChange([...value, url])} />}
      </div>
    </div>
  );
}
